import { NgModule } from '@angular/core';

import { FilterPipe, LIB_CommonModule, SearchPipe, SorterPipe } from 'pbc.angular';

import { BesichtigungenService, TourenService } from '.';

@NgModule({
  imports: [LIB_CommonModule],
  providers: [BesichtigungenService, TourenService, SearchPipe, FilterPipe, SorterPipe],
  exports: [],
})
export class TourenServiceModule {}
